import { useContext } from 'react'

import { ProviderContext } from '../../../Provider'

export const YourTheir = () => {
  const {
    state: { selectedDriverIndex },
  } = useContext(ProviderContext)

  return !selectedDriverIndex ? 'your' : 'their'
}

export const YouThey = () => {
  const {
    state: { selectedDriverIndex },
  } = useContext(ProviderContext)

  return !selectedDriverIndex ? 'you' : 'they'
}

export const YouveTheyve = () => {
  const {
    state: { selectedDriverIndex },
  } = useContext(ProviderContext)

  return !selectedDriverIndex ? `you've` : `they've`
}
